import { ProductsActionKeys as keys } from './productsActionKeys';
import * as types from './productsActionTypes';
import { IProduct } from './productsInterfaces';

export const productsActionCreators = {
  setProducts: (payload: IProduct[]): types.SetProducts => ({
    payload,
    type: keys.SET_PRODUCTS
  })
};
